
export interface AccountsState {
  accounts:AccountItem[],
  accountItem?:AccountItem,
  protocolList:any[]
}

export interface AccountItem {
  id?:number,
  login:string,
  password?:string,
  confirm_password?:string,
  partner:string,
  partner_id?:number,
  protocol:string,
  protocol_id?:number,
  transport_id?:number | null,
  transport?:string | null,
  status:number,
  push_statuses?:number,
  status_report?:number,
  url?:string|null,
  max_throughput?:string,
  immediate_response_needed?:number,
  additional_processing_rule?: string | null;
}

export class AccountFilter {
  name?: string = undefined
  login?: number = undefined
  protocol?: string = undefined
  partner?: string = undefined
  transport?: string = undefined
  status?: number = undefined
  page_number: number = 1
}

export class AccountItemImpl implements AccountItem {
  login: string;
  partner: string;
  protocol: string;
  status: number;
  push_statuses?:number;
  status_report?:number;
  max_throughput?:string;
  immediate_response_needed?:number;
  additional_processing_rule?: string;

  constructor() {
    this.login = '';
    this.partner = '';
    this.protocol = '';
    this.status = 0;
    this.push_statuses = 0;
    this.status_report = 0;
    this.max_throughput = '10/1000'
    this.immediate_response_needed = 1;
    this.additional_processing_rule = '';
  }
}